import dayjs from "dayjs";

export default function defaultIntervalSessions() {
    const today = dayjs(new Date());
    return {start: today.subtract(3, 'day').format("YYYY-MM-DD"), end: today.format("YYYY-MM-DD")}
}